import { useState, useEffect } from 'react';
import classNames from 'classnames';
import data from './prioritiesData.json';
import Styles from './Priorities.module.scss';

const Priorities = ({ searchTerm }) => {
  const [prioritiesList, setPrioritiesList] = useState();

  useEffect(() => {
    showPriorities();
  }, [searchTerm]);

  const showPriorities = () => {
    const items = [];

    data.map((section, idx) => {
      const priorities = section.priorities.filter((p) => {
        if (!searchTerm) return true;
        return p.title.toLowerCase().includes(searchTerm.toLowerCase());
      });

      priorities.length &&
        items.push(
          <div key={idx} className={Styles.section}>
            <div className={Styles.title}>{section.category}</div>
            <div className={Styles.list}>
              {priorities.map((priority, i) => {
                return (
                  <a key={i} className={classNames(Styles.item)} href={priority.href}>
                    {priority.title}
                  </a>
                );
              })}
            </div>
          </div>
        );
    });
    setPrioritiesList(items);
  };
  if (!prioritiesList && data.length) {
    showPriorities();
  }
  return <div className={Styles.container}>{prioritiesList}</div>;
};

export default Priorities;
